import PropTypes from 'prop-types'
import React from 'react'
import { Size } from '@opallabs/gem'
import { ThemeProvider } from '@opallabs/hooks'
import { Button, Icon, SectionHeading } from '@opallabs/lapidary'
import * as styles from './styles'

export const Header = ({
  onClickShare,
  onClickEdit,
  onClickExit,
  title = '',
  forNonUser = true,
  viewOnly = true,
}) => (
  <ThemeProvider theme="dark">
    <div
      className="slide-view-header-container"
      css={styles.slideViewHeaderContainer}
    >
      <div className="slide-view-header-left" css={styles.slideViewHeaderLeft}>
        {forNonUser || viewOnly ? null : (
          <React.Fragment>
            <Button
              ariaLabel="share presentation"
              variant="ghost"
              icon={
                <Icon
                  ariaHidden={true}
                  glyph="gem-share"
                  height={Size.Icon}
                  width={Size.Icon}
                />
              }
              name="share-presentation"
              onClick={onClickShare}
            />
            <Button
              ariaLabel="edit presentation"
              variant="ghost"
              icon={
                <Icon
                  ariaHidden={true}
                  glyph="gem-edit"
                  height={Size.Icon}
                  width={Size.Icon}
                />
              }
              name="edit-presentation"
              onClick={onClickEdit}
            />
          </React.Fragment>
        )}
      </div>

      <div
        className="slide-view-header-center"
        css={styles.slideViewHeaderCenter}
      >
        <SectionHeading>{title}</SectionHeading>
      </div>

      <div
        className="slide-view-header-right"
        css={styles.slideViewHeaderRight}
      >
        {forNonUser ? null : (
          <Button
            buttonText="close presentation"
            variant="ghost"
            icon={
              <Icon
                ariaHidden={true}
                glyph="gem-close"
                height={Size.Icon}
                width={Size.Icon}
              />
            }
            iconPosition="trailing"
            name="exit-presentation"
            onClick={onClickExit}
          />
        )}
      </div>
    </div>
  </ThemeProvider>
)

Header.propTypes = {
  forNonUser: PropTypes.bool,
  onClickEdit: PropTypes.func.isRequired,
  onClickExit: PropTypes.func.isRequired,
  onClickShare: PropTypes.func.isRequired,
  title: PropTypes.string,
  viewOnly: PropTypes.bool,
}
